// Lightweight address reference data for datalist-based autocomplete.
// Sorted A–Z by display name; "Other" is pinned last.
export const COUNTRIES = [
  "Argentina", "Australia", "Austria",
  "Belgium", "Brazil",
  "Cambodia", "Canada", "Chile", "China", "Colombia", "Costa Rica", "Czech Republic",
  "Denmark",
  "Ecuador", "Egypt",
  "Finland", "France",
  "Germany", "Greece",
  "Hong Kong", "Hungary",
  "India", "Indonesia", "Ireland", "Israel", "Italy",
  "Japan",
  "Kenya",
  "Laos",
  "Malaysia", "Mexico", "Myanmar",
  "Netherlands", "New Zealand", "Nigeria", "Norway",
  "Panama", "Philippines", "Poland", "Portugal",
  "Saudi Arabia", "Singapore", "South Africa", "South Korea", "Spain", "Sweden", "Switzerland",
  "Taiwan", "Thailand", "Turkey",
  "United Arab Emirates", "United Kingdom", "United States",
  "Vietnam",
  "Other",
];

export const US_STATES = [
  "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado", "Connecticut",
  "Delaware", "Florida", "Georgia", "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa",
  "Kansas", "Kentucky", "Louisiana", "Maine", "Maryland", "Massachusetts", "Michigan",
  "Minnesota", "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire",
  "New Jersey", "New Mexico", "New York", "North Carolina", "North Dakota", "Ohio",
  "Oklahoma", "Oregon", "Pennsylvania", "Rhode Island", "South Carolina", "South Dakota",
  "Tennessee", "Texas", "Utah", "Vermont", "Virginia", "Washington", "West Virginia",
  "Wisconsin", "Wyoming", "District of Columbia",
];

export const CA_PROVINCES = [
  "Alberta", "British Columbia", "Manitoba", "New Brunswick", "Newfoundland and Labrador",
  "Nova Scotia", "Ontario", "Prince Edward Island", "Quebec", "Saskatchewan",
  "Northwest Territories", "Nunavut", "Yukon",
];

export function statesForCountry(country) {
  const c = (country || "").trim().toLowerCase();
  if (["united states", "usa", "us", "u.s.", "u.s.a."].includes(c)) return US_STATES;
  if (c === "canada") return CA_PROVINCES;
  return null;
}
